import { render, staticRenderFns } from "./PhotosDisplay.vue?vue&type=template&id=cd8f676c&scoped=true&"
import script from "./PhotosDisplay.vue?vue&type=script&lang=js&"
export * from "./PhotosDisplay.vue?vue&type=script&lang=js&"
import style0 from "./PhotosDisplay.vue?vue&type=style&index=0&id=cd8f676c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd8f676c",
  null
  
)

export default component.exports